import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.min.css";
import "react-loading-skeleton/dist/skeleton.css";
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './AppStyles.css';
window.bootstrap = bootstrap;
function AppStyles({children}) {
    return children;
}
export default AppStyles